import * as React from 'react';
import { ViewStateChangeInfo } from 'react-map-gl';
import { Button, Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { GeoValidationError } from 'src/views/cPAllLocations/CPAllLocations';
import { BasedataParams, Location, ServerResponse, UploadImage } from '../../api';
import CPLocationComponent from '../cpLocationComponent/CPLocationComponent';
import { EditState } from '../itemEditComponent/ItemEditComponent';
import './CPLocationList.css';

export interface CPLocationListProps {
    addNewRecord: () => void;
    addUploadImage: (image: UploadImage) => void;
    deleteUploadImage: (index: number) => void;
    cancelHandler: () => void;
    changeHandler: (editValue: string, field: string) => void;
    deleteImageHandler: (index: number) => void;
    editItemID: number | undefined;
    editValue: Location;
    errorClass: (fieldname: string) => string;
    errors: string[];
    geoAccuracyError: boolean;
    geoCalculate: () => void;
    geoValidationErrors: GeoValidationError;
    serverResponse: ServerResponse | undefined;
    locations: Location[];
    locationPossibleParticularities: BasedataParams;
    saveHandler: () => void;
    selectEntry: (entryId: number, selectionMethod: SelectionMethod) => void;
    toggleLocationParticularity: (locationParticularity: number) => void;
    updateViewport: (info: ViewStateChangeInfo) => void;
    uploadImages: UploadImage[];
    zoomEditValue: number;
    zoomLocation: number;
}

export interface CPLocationListState {
    addNewValue: Location;
}

export enum SelectionMethod {
    Delete,
    Edit,
    None,
}

export default class CPLocationList extends React.Component<CPLocationListProps, CPLocationListState> {
    constructor(props: any) {
        super(props);
        this.state = {
            addNewValue: {
                City: '',
                Country: '',
                ID: 0,
                Images: [],
                Lat: 0,
                Long: 0,
                Name: '',
                Particulatities: [],
                Street: '',
                Telephone: '',
                Zip: '',
            },
        };
    }

    public render() {
        const ed = this.props.editItemID === undefined;

        return (
            <Container>
                <Row>
                    <Col>
                        <h3>{TR.cPLocationList_locations}</h3>
                    </Col>
                </Row>
                {this.props.locations.map(this.renderCPLocationComponent)}
                <Row>
                    <Col>
                        <Button
                            id={'newLocation'}
                            disabled={!ed}
                            onClick={() => {
                                this.props.addNewRecord();
                            }}
                        >
                            {TR.cPLocationList_add_location}
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }

    private renderCPLocationComponent = (location: Location) => {
        let editState: EditState;
        let error = false;

        if (
            this.props.editItemID === location.ID &&
            this.props.serverResponse !== undefined &&
            !this.props.serverResponse.OK
        ) {
            error = true;
        }

        if (this.props.editItemID === location.ID) {
            editState = EditState.This;
        } else if (this.props.editItemID === undefined) {
            editState = EditState.None;
        } else {
            editState = EditState.Other;
        }

        return (
            <React.Fragment key={location.ID + location.Name}>
                <CPLocationComponent
                    addUploadImage={this.props.addUploadImage}
                    cancelHandler={this.props.cancelHandler}
                    changeHandler={this.props.changeHandler}
                    deleteImageHandler={this.props.deleteImageHandler}
                    deleteUploadImage={this.props.deleteUploadImage}
                    editState={editState}
                    editValue={this.props.editValue}
                    entryId={location.ID}
                    error={error}
                    errorClass={this.props.errorClass}
                    errors={this.props.errors}
                    geoAccuracyError={this.props.geoAccuracyError}
                    geoCalculate={this.props.geoCalculate}
                    geoValidationErrors={this.props.geoValidationErrors}
                    location={location}
                    locationPossibleParticularities={this.props.locationPossibleParticularities}
                    saveHandler={this.props.saveHandler}
                    selectEntry={this.props.selectEntry}
                    serverResponse={this.props.serverResponse}
                    toggleLocationParticularity={this.props.toggleLocationParticularity}
                    updateViewport={this.props.updateViewport}
                    uploadImages={this.props.uploadImages}
                    zoomEditValue={this.props.zoomEditValue}
                    zoomLocation={this.props.zoomLocation}
                />
            </React.Fragment>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/cpLocationList/CPLocationList.tsx